import { useRef, useState } from 'react';
import { validateFile } from './utils';
import { VALIDATION_ERROR_MESSAGES } from './constants';

export const useFileDropzone = ({
  acceptedFileFormats,
  dialogType,
  maxFileCount,
}) => {
  const [imageFiles, setImageFiles] = useState(null);
  const [fileValidationErrors, setFileValidationErrors] = useState(null);
  const dropFrameRef = useRef();
  const fileInputRef = useRef();

  const imageFileCount = imageFiles?.length || 0;

  const maxDropFileCount = maxFileCount - imageFileCount;

  const validationErrorMessages = VALIDATION_ERROR_MESSAGES[dialogType];

  const handleFile = (files = [{}], e) => {
    e?.preventDefault();
    if (fileValidationErrors) {
      setFileValidationErrors(null);
    }

    const selectedFiles = Array.from(files).slice(0, maxDropFileCount);
    const validatedFiles = selectedFiles.reduce(
      (filteredFiles, file) => {
        const validationErrorType = validateFile(file, acceptedFileFormats);

        const validationErrorMessage =
          validationErrorMessages[validationErrorType];

        if (validationErrorMessage) {
          filteredFiles.inValidFiles.push({
            errorMessage: validationErrorMessage,
            fileName: file.name,
          });
          return filteredFiles;
        }

        filteredFiles.validFiles.push({
          file,
          fileUrl: URL.createObjectURL(file),
        });
        return filteredFiles;
      },
      { inValidFiles: [], validFiles: [] },
    );
    setImageFiles((prevState) => [
      ...(prevState || []),
      ...validatedFiles.validFiles,
    ]);

    setFileValidationErrors((prevState) => [
      ...(prevState || []),
      ...validatedFiles.inValidFiles,
    ]);
    fileInputRef.current.value = null;
  };

  const resetImageFiles = () => {
    setImageFiles(null);
    fileInputRef.current.value = null;
  };

  const clearFileValidationErrors = () => {
    setFileValidationErrors(null);
  };

  const deleteImageFile = (fileUrl) => {
    setImageFiles((prevState) =>
      prevState.filter((imageFile) => imageFile.fileUrl !== fileUrl),
    );
  };

  const clearFileValidationError = (fileName) => () => {
    setFileValidationErrors((prevState) =>
      prevState.filter((error) => error.fileName !== fileName),
    );
  };

  return {
    deleteImageFile,
    dropFrameRef,
    clearFileValidationErrors,
    clearFileValidationError,
    fileInputRef,
    fileValidationErrors,
    handleFile,
    imageFiles,
    maxDropFileCount,
    resetImageFiles,
  };
};
